import { render, staticRenderFns } from "./m-create-contact-errors.vue?vue&type=template&id=42c2c7ab&lang=pug"
import script from "./m-create-contact-errors.vue?vue&type=script&lang=js"
export * from "./m-create-contact-errors.vue?vue&type=script&lang=js"
import style0 from "./m-create-contact-errors.vue?vue&type=style&index=0&id=42c2c7ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports